import React from 'react'
import { Route, Switch, useParams } from 'react-router-dom'
import { url2section } from 'ion-sections'
import loadable from '@loadable/component'

const DefaultSectionPage = loadable(() => import('../pages/DefaultSectionPage'))
const VideoPage = loadable(() => import('../pages/VideoPage'))
const TagPage  = loadable(() => import('../pages/TagPage'))
const Article = loadable(() => import('../pages/Article'))

const RenderArticle = (props) => {
  const { contentKey } = useParams()
  return <Article {...props} contentKey={contentKey} />
}

const Multmedia = (props) => (
  <Switch>
    <Route path='/multimedia' exact render={() => (
      <DefaultSectionPage {...props}
        section='multimedia'
        mostReadSection='news'
        relatedSections={[{ id: 'multimedia/videos' }, { id: 'multimedia/pictures' }, { id: 'multimedia/audio' }]}
        title='Latest Multimedia Content, Galleries, Video and Audio | IOL'
        description='There is more than one way to tell a story. Visit IOL for the latest multimedia content and highlights, with featured galleries, video and audio.'
      />
    )} />
    <Route path='/multimedia/pictures' exact render={() => (
      <DefaultSectionPage {...props}
        section='multimedia/pictures'
        mostReadSection='news'
        relatedSections={[{ id: 'multimedia' }]}
        title='View the Latest Picture Galleries | IOL'
        description='Take a look at the latest picture galleries on news, sport, business, entertainment, lifestyle, travel and motoring stories and events on IOL.'
      />
    )} />
    <Route path='/multimedia/galleries' exact render={() => (
      <DefaultSectionPage {...props}
        section='multimedia/galleries'
        mostReadSection='news'
        relatedSections={[{ id: 'multimedia' }]}
        title='View the Latest Picture Galleries | IOL'
        description='Take a look at the latest picture galleries on news, sport, business, entertainment, lifestyle, travel and motoring stories and events on IOL.'
      />
    )} />
    <Route path='/multimedia/videos' exact render={() => (
      <VideoPage {...props}
        section='multimedia/videos'
        mostReadSection='news'
        sectionLabel='Video'
        relatedSections={[{ id: 'multimedia' }]}
        title='Watch the Latest Video Content | IOL'
        description='Watch the latest news, sport, business, entertainment, lifestyle, travel and motoring videos on IOL.'
      />
    )} />
    <Route path='/multimedia/front-page-videos' exact render={() => (
      <VideoPage {...props}
        section='multimedia/front-page-videos'
        mostReadSection='news'
        relatedSections={[{ id: 'multimedia' }]}
        title='Watch the Latest Video Content | IOL'
        description='Watch the latest news, sport, business, entertainment, lifestyle, travel and motoring videos on IOL.'
      />
    )} />
    <Route path='/multimedia/audio' exact render={() => (
      <DefaultSectionPage {...props}
        section='multimedia/audio'
        mostReadSection='news'
        relatedSections={[{ id: 'multimedia' }]}
        title='Listen to the Latest Audio | IOL'
        description='Listen to audio interviews and commentary, and podcasts on the latest news, sport, business, entertainment, lifestyle, travel and motoring on IOL.'
      />
    )} />
    <Route path='/multimedia/podcasts' exact render={() => (
      <DefaultSectionPage {...props}
        section='multimedia/podcasts'
        mostReadSection='news'
        relatedSections={[{ id: 'multimedia' }, { id: 'video', label: 'Video' }]}
        title='Latest News, Comments and Analysis | IOL'
        description='Listen to the latest podcast news, comments, and analysis on IOL News.'
      />
    )} />
    <Route path={'/multimedia/:section([a-zA-Z0-9-/]+)/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/multimedia/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/multimedia/:section([a-zA-Z0-9-/]+)/:title*([-])*:contentKey([0-9]{5,})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/multimedia/:title*([-])*:contentKey([0-9]{5,})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/multimedia/:section([a-zA-Z0-9-/]+)'} exact render={() => (
      <TagPage {...props}
        section={url2section(props.location.pathname)}
        url={props.location.pathname}
      />
    )} />
  </Switch>
)

export default Multmedia
